import { render } from "./IzinGuru.vue?vue&type=template&id=422a663d&scoped=true"
import script from "./IzinGuru.vue?vue&type=script&lang=js"
export * from "./IzinGuru.vue?vue&type=script&lang=js"

import "./IzinGuru.vue?vue&type=style&index=0&id=422a663d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422a663d"]])

export default __exports__